import { combineReducers } from '@reduxjs/toolkit';

import { apiSlice } from './features/api/apiSlice';
import downloadOptionReducer from './features/downloadOption/downloadOptionSlice';
import fileRepertoireReducer from './features/fileRepertoire/fileRepertoireSlice';
import messageListReducer from './features/messageList/messageListSlice';
import statisticsOptionReducer from './features/statisticsOption/statisticsOptionSlice';
import viewConfigReducer from './features/viewConfig/viewConfigSlice';
import viewer1dOptionReducer from './features/viewer1dOption/viewer1dOptionSlice';
import viewer2dOptionReducer from './features/viewer2dOption/viewer2dOptionSlice';

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  downloadOption: downloadOptionReducer,
  fileRepertoire: fileRepertoireReducer,
  messageList: messageListReducer,
  statisticsOption: statisticsOptionReducer,
  viewConfig: viewConfigReducer,
  viewer1dOption: viewer1dOptionReducer,
  viewer2dOption: viewer2dOptionReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
